<template>
  <div class="preload">
    <object data="/images/logoanim.svg" type="image/svg+xml"></object>
  </div>
</template>

<script>
export default {
  name: "Preload"
}
</script>